import React from 'react';
import { ContainerMore } from './style.css';
import asiEmpieza from "../../images/asi-empieza.png"
import carcel from "../../images/luces-en-la-carcel.jpg"
import brechaDigital from "../../images/brecha-digital.png"

const More = () => {
    return (
        <ContainerMore
        data-sal="slide-right"
        data-sal-delay="2000"
        data-sal-easing="ease"
        >
            <div className="item1">
                <a href="https://www.latercera.com/asi-empieza/" target="_blank">
                <img src={asiEmpieza} alt="props" />
                <p>Así Empieza</p>
                </a>
            </div>
            <div className="item2">
            <a href="https://especiales.latercera.com/luces-en-la-carcel-loreal/" target="_blank">
                <img src={carcel} alt="props" />
                <p>Luces en la Carcel</p>
                </a>
            </div>
            <div className="item3">
            <a href="http://especiales.latercera.com/entel-brechadigital/" target="_blank">
                <img src={brechaDigital} alt="props" />
                <p>Brecha Digital</p>
                </a>
            </div>
        </ContainerMore>
    );
}

export default More;